export default __webpack_public_path__ + "static/media/informations reçues sur le patrimoine bati.37e6573c.svg";